import { render } from "./ForecastScale.vue?vue&type=template&id=235d0206&scoped=true"
import script from "./ForecastScale.vue?vue&type=script&lang=js"
export * from "./ForecastScale.vue?vue&type=script&lang=js"

import "./ForecastScale.vue?vue&type=style&index=0&id=235d0206&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235d0206"]])

export default __exports__